<template>
  <div class="h-1 bg-grey-200" />
</template>

<script>
export default {}
</script>

<style></style>
